<template>
    <m-assembly-table
        :formData="formData"
        :columns="tableColumns"
        :data="tableData"
        :currentPage="settings.currentPage"
        :pageSize="settings.pageSize"
        :settings="settings"
        :tableButtons="tableButtons"
        :loading="loading"
        :total="settings.total"
        @onSubmit="onSubmit"
        @onPageSizeChange="onPageSizeChange"
        @onCurrentPageChange="onPageChange"
        @onSelectionChange="onSelectionChange"
        ref="searchForm">
    </m-assembly-table>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index';
import moment from 'moment';
import axios from 'axios';

export default {
    name: 'UIDLabelPrintHistory',
    components: {
        mAssemblyTable,
    },
    data() {
        return {
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'orgCode',
                        disabled: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t1'), // 买方组织不能为空
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        methods: {
                            change: (val) => {
                            },
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('UIDLabelPrint.t2'), // 买方组织
                    },
                    {
                        value: '',
                        field: 'vendorCode',
                        readonly: true,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t3'), // 供应商编码不能为空
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('UIDLabelPrint.t4'), // 供应商编码
                    },
                    {
                        value: '',
                        field: 'itemCode',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('UIDLabelPrint.t6'), // 物料编码
                    },
                    {
                        value: '',
                        field: 'tagUid',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: 'UID', // UID
                    },
                    {
                        value: '',
                        field: 'creationDateStart',
                        editable: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t31'), // 创建日期不能为空
                            },
                        },
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0,
                        },
                        style: 'width:100%',
                        options: {
                            type: 'datetime',
                            format: 'yyyy-MM-dd',
                            needFormat: false,
                            options: {},
                        },
                        type: 'datePicker',
                        title: this.$t('UIDLabelPrint.t32'), // 创建日期
                        isDouble: true,
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'creationDateEnd',
                        editable: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t31'), // 创建日期不能为空
                            },
                        },
                        style: 'width:100%',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            type: 'datetime',
                            format: 'yyyy-MM-dd',
                            needFormat: false,
                            options: {},
                        },
                        placeholder: '',
                        type: 'datePicker',
                        title: '',
                    },
                ],
            },
            tableColumns: {
                columns: [
                    {
                        type: 'selection',
                        align: 'center',
                        width: 35,
                    },
                    {
                        title: 'UID',
                        key: 'tagUid',
                        align: 'center',
                        width: 170,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t4'), // 供应商编码
                        key: 'vendorCode',
                        align: 'center',
                        width: 100,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t28'), // 供应商简称
                        key: 'vendorNameAlt',
                        align: 'center',
                        width: 100,
                        tooltip: true,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t9'), // 物料型号/材质
                        key: 'partType',
                        align: 'center',
                        width: 200,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t8'), // 物料描述
                        key: 'itemDescription',
                        align: 'center',
                        width: 250,
                        tooltip: true,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t6'), // 物料编码
                        key: 'itemCode',
                        align: 'center',
                        width: 150,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t15'), // 最小包装数量
                        key: 'qty',
                        align: 'center',
                        width: 110,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t29'), // 单位
                        key: 'unit',
                        align: 'center',
                        width: 100,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t11'), // 批次号
                        key: 'lotNo',
                        align: 'center',
                        width: 200,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t13'), // 生产日期
                        key: 'mdate',
                        align: 'center',
                        width: 110,
                        render: (h, params) => {
                            return h('span', moment(params.row.mdate).format('YYYY-MM-DD'));
                        },
                    },
                    {
                        title: this.$t('UIDLabelPrint.t19'), // 过期日期
                        key: 'expirtDate',
                        align: 'center',
                        width: 110,
                        render: (h, params) => {
                            return h('span', moment(params.row.expirtDate).format('YYYY-MM-DD'));
                        },
                    },
                    {
                        title: this.$t('UIDLabelPrint.t33'), // 打印次数
                        key: 'printCount',
                        align: 'center',
                        width: 90,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t41'), // 最后打印时间
                        key: 'lastPrintDate',
                        align: 'center',
                        width: 160,
                        render: (h, params) => {
                            return h('span', moment(params.row.lastPrintDate).format('YYYY-MM-DD HH:mm:ss'));
                        },
                    },
                ],
            },
            tableData: [],
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                onlyLeftPart: false,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            tableButtons: {
                customButtons: [
                    {
                        name: '',
                        label: this.$t('UIDLabelPrint.t23'), // 补打标签
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        disabled: () => this.selection.length === 0,
                        click: (button) => {
                            button.loading = true;
                            this.rePrintUid()
                                .finally(() => {
                                    button.loading = false;
                                });
                        },
                    },
                ],
            },
            selection: [],
            loading: false,
        };
    },
    methods: {
        onSubmit(currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        onPageSizeChange(currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onSelectionChange(selection) {
            this.selection = selection;
        },
        onSearch() {
            this.loading = true;
            axios.post('/gscint/uidTag/queryHistory', {
                ...this.getFormDataVModel(this.formData.items),
                pageNum: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                vendorCode: this.vendorCode,
            })
                .then((res) => {
                    const { list, total } = res.data.data;
                    if (list) {
                        this.selection = [];
                        this.tableData = list;
                        this.settings.total = total;
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        rePrintUid() {
            return axios.post('/gscint/uidTag/rePrintUid', {
                uidList: this.selection.map((item) => item.tagUid).join(),
            })
                .then((res) => {
                    const { code, msg: content } = res.data.data;
                    if (code === '1') {
                        this.onSearch();
                        const reportlets = this.selection.reduce((prev, { tagUid: uid, orgCode, vendorNameAlt: vendorAddress, vendorCode: vendor, itemCode: ipn, itemDescription: partDesc, partType, lotNo, mdate, qty, tagCount, expirtDate, unit }) => {
                            const qrCode = `@U${uid}@V${vendor}@M${ipn}@Q${qty}@L${lotNo}@D${moment(mdate).format('YYYYMMDD')}@`;
                            return prev.concat({
                                uid,
                                orgCode,
                                vendorAddress,
                                vendor,
                                ipn,
                                partDesc,
                                partType,
                                lotNo,
                                mDate: mdate,
                                qty,
                                tagCount,
                                expiryDate: expirtDate,
                                unit,
                                qrCode,
                            });
                        }, []);
                        this.cloudPrint('hw-uidTag', { reportlets });
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                })
                .catch((err) => {
                    this.showErrorTips();
                });
        },
    },
    mounted() {
        this.getSRMInvLovListNew((data) => {
            this.getFormDataItemObj(this.formData.items, 'orgCode').options.values = data.map((item) => { 
                return {
                    value: item.organizationCode,
                    label: item.organizationName,
                };
            });
        });
        this.getFormDataItemObj(this.formData.items, 'vendorCode').value = this.vendorCode;
    },
};

</script>
